module.exports = __webpack_public_path__ + "static/img/title.7b9735d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/city-agent/title.png
// module id = NgvG
// module chunks = 4